import useWebChatUIContext from '/druid/useWebChatUIContext';

function useInternalRenderMarkdownInline() {
  const { internalRenderMarkdownInline } = useWebChatUIContext();

  return internalRenderMarkdownInline;
}

export default useInternalRenderMarkdownInline;
